const CloseIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17.678'
      height='17.678'
      viewBox='0 0 17.678 17.678'
    >
      <g
        id='Group_6618'
        data-name='Group 6618'
        transform='translate(-1163.737 -189.161)'
      >
        <path
          id='Line_61'
          data-name='Line 61'
          d='M0,22a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V21A1,1,0,0,1,0,22Z'
          transform='translate(1180 190.575) rotate(45)'
          fill='#525252'
        />
        <path
          id='Line_62'
          data-name='Line 62'
          d='M0,22a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V21A1,1,0,0,1,0,22Z'
          transform='translate(1180 205.425) rotate(135)'
          fill='#525252'
        />
      </g>
    </svg>
  );
};

export default CloseIcon;
